// removed by extract-text-webpack-plugin
module.exports = {"news-block":"_3T0fA1flgQFhQj6VVLNxLY","frontpage":"_2Leki8gwGpWVWutlxLZSzw","horizontal":"_2NXrcEVvaSUCL_qECc8j7c","text":"Io4jb_O-5xRhHgPER5zdp","heading":"_1UsJRcdQg0nZVoGwEmX_CA","paragraph":"_3yq4w9Wu2r6n18r3acMyad","link":"_3dC1krjfkCbCy2jiXUHXYF","image":"_3jUKKW83gWkU91pqSaNy1s"};


//////////////////
// WEBPACK FOOTER
// ./src/components/NewsBlock/NewsBlock.module.scss
// module id = 791
// module chunks = 0